import React from 'react'
import DocumentTitle from 'react-document-title'
import docsSidebar from '../pages/ftbModules/doc-links.yaml'
import Nav from '../components/Nav'
import Footer from '../components/Footer'
import DocSidebar from '../components/DocSidebar'
import Sticky from 'react-sticky-state'
import StickySidebar from '../components/StickySidebar'
import Header from '../components/Header'
import Auth from '../utils/auth';
import BodyContent from '../components/BodyContent'


const auth = new Auth();

DocumentTitle.displayName = 'Document Title'

const hhsCx = 'pad-r-1 flex-box dir-column m-marg-t-2 m-marg-l-2 hhs'
const hhsACx = 'clr-white relative hhs'

class Layout extends React.Component {
  constructor(props: Object) {
    super(props)

    this.state = {
      sidebarFixed: false,
    }

    this.toggleSidebarFixed = this.toggleSidebarFixed.bind(this)
  }

  toggleSidebarFixed(fixed) {
    this.setState({
      sidebarFixed: fixed,
    })
  }

  render() {
    const scrollClass = {
      down: 'sticky-scroll-down',
      up: 'sticky-scroll-up',
    }

    
    const hasSidebar = this.props.location.pathname.slice(0, 12) === `/ftbModules/`;
  

    return (
      <DocumentTitle title="ftbcAcademy" key="ftbcAcademy">
        <div>
          <div className="header-main menu-shadow bg-primary-darker pad-t-1 pad-b-1">
            <Header/>
          </div>
          <Sticky scrollClass={scrollClass}>
            <div className="sticky" id="nav">
              <Nav meta={this.props.meta} />
            </div>
          </Sticky>
          {hasSidebar && (
            <div
              className="body-container body-doc-container"
              id="body-doc-container"
            >
              <StickySidebar
                enter="58"
                sidebarFixed={this.state.sidebarFixed}
                toggleFixed={this.toggleSidebarFixed}
              >
                <DocSidebar inline yaml={docsSidebar} />
              </StickySidebar>
              <div
                className={
                  'doc-container ' +
                  (this.state.sidebarFixed ? 'fixed-padding' : '')
                }
                id="doc-container"
              >
                <BodyContent 
                        content={this.props.children()}
                        freeOrNot={this.props.location.pathname}
                      />
              </div>
            </div>
          )}
          {!hasSidebar && (
            <div className="body-container">{this.props.children()}</div>
          )}
          {!hasSidebar && <Footer />}
        </div>
      </DocumentTitle>
    )
  }
}

Layout.displayName = 'Layout'
export default Layout



// WEBPACK FOOTER //
// ./src/layouts/indexFtbModules.js